import ReCAPTCHA from "react-google-recaptcha";

import React from "react";

const { REACT_APP_GOOGLE_RECAPTCHA_KEY } = process.env;

export const Recaptcha = ({ onSubmitRecaptchaHandler }) => {
  const onClickRecaptchaHandler = (value) => {
    if (!!value) {
      onSubmitRecaptchaHandler(true);
    }
  };

  return (
    <ReCAPTCHA
      sitekey={REACT_APP_GOOGLE_RECAPTCHA_KEY}
      onChange={onClickRecaptchaHandler}
    />
  );
};
